import { render, staticRenderFns } from "./homemateWrapper.vue?vue&type=template&id=d622092e"
import script from "./homemateWrapper.vue?vue&type=script&lang=js"
export * from "./homemateWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports